module.exports = __webpack_public_path__ + "28d455eaef98f31ead884c5a6d4abf03.svg";